// src/router/admin/store.ts
import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups'

export const adminStoreRoutes: RouteRecordRaw[] = [
  {
    path: 'store',
    name: 'admin.store.index',
    component: () => import('../../views/admin/store/BoraStoreView.vue'),
    meta: {
      title: 'BORAstore',
      requiresAuth: true,
      requireRoles: ROLE_GROUPS.ADMIN_PANEL,
    },
  },
]
